
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.592 14.225a.6.6 0 01-.885-.653l.86-3.752-2.973-2.726a.6.6 0 01.402-1.042l3.96-.028 1.482-3.942a.6.6 0 011.126.006l1.432 3.945 4.007.019a.6.6 0 01.4 1.045l-3.014 2.732.902 3.736a.6.6 0 01-.882.66L7.993 12.26l-3.401 1.965z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    